import { render, staticRenderFns } from "./FeedbackContainer.vue?vue&type=template&id=4cb65d3e&scoped=true"
import script from "./FeedbackContainer.vue?vue&type=script&lang=ts"
export * from "./FeedbackContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb65d3e",
  null
  
)

export default component.exports